module.exports = __webpack_public_path__ + "static/media/02-benefit-free-entries.8b888ee2.jpg";